// extracted by mini-css-extract-plugin
export var quillEditor = "_op-1";
export var variable = "_op-0";